import { Pipe, PipeTransform } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PricesObj } from 'src/app/models/beat-list-model';
import { LicenceDataModel } from 'src/app/models/lic-list.model';
import { LicenseSlug } from 'src/app/models/selected-files-data';
import { BeatsService } from 'src/app/services/beats-service/beats.service';
import { BrowserStorageService } from 'src/app/services/browser-storage/browser-storage.service';

@Pipe({
  name: 'getPriceValue'
})
export class GetPriceValuePipe implements PipeTransform {
  licenceData:Array<any> = [];
  constructor(private beatService: BeatsService,
    private browserService: BrowserStorageService,
    private activatedRoute: ActivatedRoute) {
  }
  transform(priceData: Array<PricesObj>, type: string, callingFrom:any = '', sale: string = ""): any {
    let finalPrice:any = "0";
    if (this.browserService.getLicData().length > 0) {
      this.licenceData = this.browserService.getLicData();
      finalPrice = this.getPiceValue(type,priceData, callingFrom, sale);
    } else {
      this.beatService.getLicence().subscribe((res: Array<LicenceDataModel>) => {
        this.licenceData = res;
        finalPrice = this.getPiceValue(type,priceData, callingFrom, sale);
     });
    }
    return finalPrice;
  }

  getPiceValue(type: string, priceData: Array<PricesObj>, callingFrom: string, sale: string) {
    let finalPrice: any = "0";
    if (type === 'single') {
      let selectedLicSlug: any = "";
      if (this.activatedRoute.snapshot.queryParams['beats_with_exclusives']) {
        selectedLicSlug = LicenseSlug.Exclusive;
      } else if (this.activatedRoute.snapshot.queryParams['wav_stems_1999']) {
        selectedLicSlug = LicenseSlug.WavStem;
      } else if (this.activatedRoute.snapshot.queryParams['wav_under_999']) {
        selectedLicSlug = LicenseSlug.Wav;
      }
      if (selectedLicSlug) {
        // URL param forced a specific license — keep existing behaviour
        for (let data of this.licenceData) {
          const found: any = priceData.find(item => this.getLicId(item.licence) === data._id && selectedLicSlug === data.slug);
          if (found) {
            finalPrice = sale
              ? (callingFrom.length ? this.getPriceValue(found?.discount?.value) : this.getPriceValue(found?.final_price_platform_sale))
              : (callingFrom.length ? this.getPriceValue(found?.discount?.value) : this.getPriceValue(found?.final_price));
            break;
          }
        }
      } else {
        // No forced slug — prefer WAV; fall back to the minimum available price
        const wavLicData = this.licenceData.find(d => d.slug === LicenseSlug.Wav);
        const wavPrice: any = wavLicData
          ? priceData.find(item => this.getLicId(item.licence) === wavLicData._id)
          : null;

        if (wavPrice) {
          // WAV is available — show WAV price
          finalPrice = sale
            ? (callingFrom.length ? this.getPriceValue(wavPrice?.discount?.value) : this.getPriceValue(wavPrice?.final_price_platform_sale))
            : (callingFrom.length ? this.getPriceValue(wavPrice?.discount?.value) : this.getPriceValue(wavPrice?.final_price));
        } else {
          // WAV not available — show the minimum final_price across all available licenses
          let minFound: any = null;
          for (let data of this.licenceData) {
            const found: any = priceData.find(item => this.getLicId(item.licence) === data._id);
            if (found) {
              const candidatePrice = sale ? (found?.final_price_platform_sale ?? found?.final_price) : found?.final_price;
              const minPrice = sale ? (minFound?.final_price_platform_sale ?? minFound?.final_price) : minFound?.final_price;
              if (!minFound || (candidatePrice !== undefined && candidatePrice < minPrice)) {
                minFound = found;
              }
            }
          }
          if (minFound) {
            finalPrice = sale
              ? (callingFrom.length ? this.getPriceValue(minFound?.discount?.value) : this.getPriceValue(minFound?.final_price_platform_sale))
              : (callingFrom.length ? this.getPriceValue(minFound?.discount?.value) : this.getPriceValue(minFound?.final_price));
          }
        }
      }
    }else if (type === "licenceObj") {
      let finalPriceObj: any = [];
      finalPriceObj = priceData.filter((priceObj: any) => {
        let found = this.licenceData.find((item: any) => item._id === priceObj.licence);
        priceObj['slug'] = found ? found.slug : "";
        priceObj['title'] = found ? found.title : "";
        if (found) {
          switch (found.slug) {
            case LicenseSlug.Exclusive:
              priceObj['order'] = 3;
              break;
            case LicenseSlug.WavStem:
              priceObj['order'] = 2;
              break;
            case LicenseSlug.Wav:
              priceObj['order'] = 1;
              break;
            default:
              priceObj['order'] = 0;
              break;
          }
        }
        return priceObj;
      })
      finalPrice = finalPriceObj;
    } else  {
        let priceObjectData:any =  this.letRangePriceValue(priceData, type);
        if (priceObjectData) {
          if (sale) {
            finalPrice = callingFrom.length ? this.getPriceValue(priceObjectData?.discount?.value) : this.getPriceValue(priceObjectData?.final_price_platform_sale);
          } else {
            finalPrice = callingFrom.length ? this.getPriceValue(priceObjectData?.discount?.value) : this.getPriceValue(priceObjectData?.final_price);
          }
          
        }
    }
    return finalPrice;
  }

  letRangePriceValue (priceData: any, type: string) {
    let licenceDataTemp: Array<any> = JSON.parse(JSON.stringify(this.licenceData));
    licenceDataTemp = type === 'startPrice' ? licenceDataTemp :  licenceDataTemp.reverse();
    if (priceData.length > 0) {
      for (let licData of licenceDataTemp) {
          let found  =  priceData.find( (priceObj: any) => this.getLicId(priceObj.licence) === licData._id);
          if (found) {
              found['slug'] = licData.slug;
              return found
          }
      }
    } else {
      return priceData[0];
    }
  }

  getLicId(licence: any) {
    if (licence) {
      return typeof(licence)  === "string"  ? licence : licence._id
    }
    return 0;
  }


  getPriceValue(price: any) {
    let finalPrice: any = "";
    if (typeof(price) === "number") {
        finalPrice = price;
    } else {
       if (price) {
          finalPrice = price.toString();
       }
    }
    return finalPrice;
  }
}
